import { Alert, Button, Card, CardContent, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { executeShellCommandJson, type ShellResponse } from '../../api/shell';
import { ResultTable } from '../../components/ResultTable';
import { sanitizeShellArg } from '../../utils/shell';

export function SaveInspector() {
  const [caseId, setCaseId] = useState('');
  const [playerId, setPlayerId] = useState('');
  const [result, setResult] = useState<ShellResponse | null>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleGetSave() {
    if (!caseId.trim() || !playerId.trim()) return;
    setLoading(true);
    setError('');
    try {
      const res = await executeShellCommandJson(`save.get ${sanitizeShellArg(caseId)} ${sanitizeShellArg(playerId)}`);
      setResult(res);
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : 'Request failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Stack spacing={3}>
      <Card sx={{ bgcolor: '#1a1d22' }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6">Inspect Save</Typography>
            <Stack direction="row" spacing={2}>
              <TextField
                label="Case ID"
                value={caseId}
                onChange={(e) => setCaseId(e.target.value)}
                fullWidth
                size="small"
                placeholder="UUID"
              />
              <TextField
                label="Player ID"
                value={playerId}
                onChange={(e) => setPlayerId(e.target.value)}
                fullWidth
                size="small"
                placeholder="UUID"
              />
              <Button variant="contained" onClick={handleGetSave} disabled={loading}>
                Get
              </Button>
            </Stack>
            {result && <ResultTable data={result} />}
          </Stack>
        </CardContent>
      </Card>

      {error && <Alert severity="error">{error}</Alert>}
    </Stack>
  );
}
